import { createWebHistory, createRouter } from "vue-router";
import store from "../store/store";
import Login from '../components/authComponents/LoginComponent.vue';
import Register from '../components/authComponents/RegisterComponent.vue';
import NavBar from '../components/otherComponents/NavBarComponent.vue';
import Accueil from '../components/otherComponents/AccueilComponent.vue';
import ContactezNous from '../components/otherComponents/ContactezNousComponent.vue';
import Panier from '../components/otherComponents/PanierComponent.vue';
import Boutiques from '../components/otherComponents/BoutiqueComponent.vue';
import Profil from '../components/profilComponents/ProfilComponent.vue';
import InfoProfil from '../components/profilComponents/InfoProfilComponent.vue';
import MesAbonnee from '../components/profilComponents/MesAbonneeComponent.vue';
import MesArticles from '../components/profilComponents/MesArticles/MesArticlesComponent.vue';
import MesStatistique from '../components/profilComponents/MesStatistiqueComponent.vue';
import AddProduct from '../components/otherComponents/AddProductComponent.vue';
import EditProduct from '../components/otherComponents/EditProductComponent.vue';
import ToutMesArticles from '../components/profilComponents/MesArticles/ToutMesArtclesComponent.vue';
import MesArticleEnVente from '../components/profilComponents/MesArticles/MesArticlesEnVentesComponent.vue';
import MesArticleEnCourDeVente from '../components/profilComponents/MesArticles/MesArticlesEnCourDeVenteComponent.vue';
import MesArticleNonVendus from '../components/profilComponents/MesArticles/MesArticlesNonVendusComponent.vue';
import MesArticleVendus from '../components/profilComponents/MesArticles/MesArticlesVendusComponent.vue';
import DetailPage from '../components/otherComponents/DetailPageComponent.vue';
import OtherProfil from '../components/otherProfilComponents/ViewOtherProfilComponent.vue';
import InfoProfilOther from '../components/otherProfilComponents/InfoProfilOtherComponent.vue';
import SesArticle from '../components/otherProfilComponents/SesArticlesComponent.vue';
import Enchere from '../components/otherComponents/EnchereComponent.vue';
import SalonEnchere from '../components/otherComponents/SalonEnchereComponent.vue';
import MesCommandes from '../components/profilComponents/MesCommande/MesCommandesComponent.vue';
import ToutMesCommandes from '../components/profilComponents/MesCommande/ToutMesCommandesComponent.vue';
import RecusValides from '../components/profilComponents/MesCommande/RecusValidesComponent.vue';
import RecusAnnules from '../components/profilComponents/MesCommande/RecusAnnulesComponent.vue';
import RecusEncourLivraison from '../components/profilComponents/MesCommande/RecusEnCourLivraisonComponent.vue';
import RecusEncourRecuperation from '../components/profilComponents/MesCommande/RecusEnCourRecuperationComponent.vue';
import MonPorteFeuille from '../components/profilComponents/PorteMonnaieComponents/MonPorteFeuilleComponent.vue';
import ToutesMesTranstions from '../components/profilComponents/PorteMonnaieComponents/ToutesMesTransactionComponent.vue';
import Debit from '../components/profilComponents/PorteMonnaieComponents/DebitComponent.vue';
import Credit from '../components/profilComponents/PorteMonnaieComponents/CreditComponent.vue';
import NotfoundComponent from "../components/otherComponents/NotfoundComponent.vue";

const routes = [
    {
        path: '/login',
        component: Login
    },
    {
        path: '/register',
        component: Register
    },
    {
        path: "/:catchAll(.*)", 
        component: NotfoundComponent, 
      },
    {
        path: '/',
        component: NavBar,
        redirect: {name: 'accueil'},
        children: [
            {
                path: '',
                name: 'accueil',
                components: {
                    default: NavBar,
                    two: Accueil,
                },
            },
            {
                path: '/contactez-nous',
                name: 'contactez-nous',
                components: {
                    default: NavBar,
                    two: ContactezNous,
                },
            },
            {
                path: '/panier',
                name: 'panier',
                components: {
                    default: NavBar,
                    two: Panier,
                },
            },
            {
                path: '/boutiques',
                name: 'boutiques',
                components: {
                    default: NavBar,
                    two: Boutiques,
                },
            },
            {
                path: '/encheres',
                name: 'encheres',
                components: {
                    default: NavBar,
                    two: Enchere,
                },
            },
            {
                path: '/salon_enchere',
                name: 'salon_enchere',
                components: {
                    default: NavBar,
                    two: SalonEnchere,
                },
                props: {
                    default: true,
                    two: true,
                    newsletterPopup: false 
                }, 
            },
            {
                path: '/details',
                name: 'details',
                components: {
                    default: NavBar,
                    two: DetailPage,
                },
                props: {
                    default: true,
                    two: true,
                    newsletterPopup: false 
                }, 
            },
            {
                path: '/edit_produit',
                name: 'edit_produit',
                components: {
                    default: NavBar,
                    two: EditProduct,
                },
                props: {
                    default: true,
                    two: true,
                    newsletterPopup: false 
                }, 
            },
            {
                path: '/ajouter_produit',
                name: 'ajouter_produit',
                components: {
                    default: NavBar,
                    two: AddProduct,
                },
            },
            {
                path: '/profil',
                name: 'profil',
                components: {
                    default: NavBar,
                    two: Profil,
                },
                redirect: {name: 'infoprofil'},
                children: [
                    {
                        path: '/infoprofil',
                        name: 'infoprofil',
                        components: {
                            default: Profil,
                            three: InfoProfil,
                        },
                    },
                    {
                        path: '/mes-abonnees',
                        name: 'mes-abonnees',
                        components: {
                            default: Profil,
                            three: MesAbonnee,
                        },
                    },
                    {
                        path: '/mes-commandes',
                        name: 'mes-commandes',
                        components: {
                            default: Profil,
                            three: MesCommandes,
                        },
                        redirect: {name: 'mes-commandes'},
                        children: [
                            {
                                path: '',
                                name: 'tout_mes_commande',
                                components: {
                                    default: MesCommandes,
                                    seven: ToutMesCommandes,
                                },
                            },
                            {
                                path: '/recus-valides',
                                name: 'recus-valides',
                                components: {
                                    default: MesCommandes,
                                    seven: RecusValides,
                                },
                            },
                            {
                                path: '/recus-annules',
                                name: 'recus-annules',
                                components: {
                                    default: MesCommandes,
                                    seven: RecusAnnules,
                                },
                            },
                            {
                                path: '/recus-en-cours-livraison',
                                name: 'recus-en-cours-livraison',
                                components: {
                                    default: MesCommandes,
                                    seven: RecusEncourLivraison,
                                },
                            },
                            {
                                path: '/recus-en-cours-recuperation',
                                name: 'recus-en-cours-recuperation',
                                components: {
                                    default: MesCommandes,
                                    seven: RecusEncourRecuperation,
                                },
                            },
                        ]
                    },
                    {
                        path: '/mes-articles',
                        name: 'mes-articles',
                        components: {
                            default: Profil,
                            three: MesArticles,
                        },
                        redirect: {name: 'mes-articles'},
                        children: [
                            {
                                path: '',
                                name: 'tout',
                                components: {
                                    default: MesArticles,
                                    fourth: ToutMesArticles,
                                },
                            },
                            {
                                path: '/en-vente',
                                name: 'en-vente',
                                components: {
                                    default: MesArticles,
                                    fourth: MesArticleEnVente,
                                },
                            }, 
                            {
                                path: '/en-cour-de-vente',
                                name: 'en-cour-de-vente',
                                components: {
                                    default: MesArticles,
                                    fourth: MesArticleEnCourDeVente,
                                },
                            },
                            {
                                path: '/non-vendus',
                                name: 'non-vendus',
                                components: {
                                    default: MesArticles,
                                    fourth: MesArticleNonVendus,
                                },
                            },
                            {
                                path: '/vendus',
                                name: 'vendus',
                                components: {
                                    default: MesArticles,
                                    fourth: MesArticleVendus,
                                },
                            },
                        ]
                    },
                    {
                        path: '/mon-porte-feuille',
                        name: 'mon-porte-feuille',
                        components: {
                            default: Profil,
                            three: MonPorteFeuille,
                        },
                        redirect: {name: 'mon-porte-feuille'},
                        children: [
                            {
                                path: '',
                                name: 'toutes-mes-transaction',
                                components: {
                                    default: MonPorteFeuille,
                                    eight: ToutesMesTranstions,
                                },
                            },
                            {
                                path: '/credits',
                                name: 'credits',
                                components: {
                                    default: MonPorteFeuille,
                                    eight: Credit,
                                },
                            },
                            {
                                path: '/debits',
                                name: 'debits',
                                components: {
                                    default: MonPorteFeuille,
                                    eight: Debit,
                                },
                            },
                        ]
                    },
                    {
                        path: '/mes-statistiques',
                        name: 'mes-statistiques',
                        components: {
                            default: Profil,
                            three: MesStatistique, 
                        },
                    },
                ]
            },
            {
                path: '/viewprofil',
                name: 'viewprofil',
                redirect: {name: 'infoprofilother'},
                components: {
                    default: NavBar,
                    two: OtherProfil, 
                },
                props: {
                    default: true,
                    two: true,
                    newsletterPopup: false 
                },
                children: [
                    {
                        path: '/infoprofilother',
                        name: 'infoprofilother',
                        components: {
                            default: OtherProfil,
                            five: InfoProfilOther,
                        },
                    },
                    {
                        path: '/ses-articles',
                        name: 'ses-articles',
                        components: {
                            default: OtherProfil,
                            five: SesArticle,
                        },
                        //redirect: {name: 'mes-articles'},
                        // children: [
                        //     {
                        //         path: '',
                        //         name: 'tout',
                        //         components: {
                        //             default: SesArticle,
                        //             six: ToutMesArticles,
                        //         },
                        //     },
                        //     {
                        //         path: '/en-vente',
                        //         name: 'en-vente',
                        //         components: {
                        //             default: SesArticle,
                        //             six: MesArticleEnVente,
                        //         },
                        //     }, 
                        //     {
                        //         path: '/non-vendu',
                        //         name: 'non-vendu',
                        //         components: {
                        //             default: MesArticles,
                        //             fourth: MesArticleNonVendus,
                        //         },
                        //     },
                        // ]
                    },
                ]
            },
        ]
    },
]

const router = createRouter({
    history: createWebHistory(),
    routes,
});

router.beforeEach((to, from, next) => {
    if(document.getElementById('navbar')){
        store.dispatch('requestRouterLastPosition', {name:from.name, scrollPosition:document.getElementById('navbar').scrollTop}) 
    }  
    return next()
})


export default router;